import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBueBbCMNqgdQykN6w4aOYoZci3EwTfci8",
  authDomain: "oiltanksweep.firebaseapp.com",
  projectId: "oiltanksweep",
  storageBucket: "oiltanksweep.firebasestorage.app",
  messagingSenderId: "856028194739",
  appId: "1:856028194739:web:c90ae62228ef60f149cdc6",
  measurementId: "G-QSWTTKFPLR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Check if we're on a share page
const isSharePage = window.location.pathname.includes('share-report');

// Initialize Firestore with minimal settings for share pages
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  useFetchStreams: false,
  cacheSizeBytes: 1048576  // Minimum required cache size (1MB)
});

// Only enable persistence on non-share pages
if (!isSharePage) {
  enableIndexedDbPersistence(db, { synchronizeTabs: true })
    .catch((err) => {
      if (err.code === 'failed-precondition') {
        // Multiple tabs open, persistence can only be enabled in one tab at a time
        console.warn('Multiple tabs open, persistence disabled');
      } else if (err.code === 'unimplemented') {
        // The current browser doesn't support persistence
        console.warn('Browser does not support persistence');
      }
    });
}

const auth = getAuth(app);
const storage = getStorage(app);

export { app, db, auth, storage }; 